module.exports = __webpack_public_path__ + "img/SK47251336.261400ad.png";